import { Search, Gavel, Repeat } from "lucide-react";

const steps = [
  { num: 1, icon: Search, title: "Analyse", text: "Lückenlose forensische Untersuchung aller Transaktionspfade auf der Blockchain und Identifizierung von Off-Ramps." },
  { num: 2, icon: Gavel, title: "Sicherung", text: "Einleitung sofortiger juristischer Maßnahmen und Erwirkung von Kontosperren bei Börsen und Finanzinstituten." },
  { num: 3, icon: Repeat, title: "Rückführung", text: "Koordinierte Wiederbeschaffung des Kapitals durch Kooperation mit Behörden und regulierten Plattformen." },
];

export function Process() {
  return (
    <section className="bg-secondary/40 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight md:text-4xl">
            Ihr Weg zur Kapitalrückführung
          </h2>
          <p className="mt-3 text-muted-foreground">
            Unser strukturierter Prozess kombiniert technologische Forensik mit juristischer Expertise für maximale Erfolgschancen.
          </p>
        </div>
        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {steps.map((s) => (
            <div key={s.num} className="relative rounded-xl border border-border bg-card p-6 text-center shadow-[var(--shadow-card)]">
              <div className="absolute -top-3 left-6 inline-flex h-8 w-8 items-center justify-center rounded-md bg-gold text-sm font-bold text-navy-deep shadow-md">
                {s.num}
              </div>
              <div className="mx-auto mb-3 mt-2 inline-flex h-12 w-12 items-center justify-center rounded-full bg-secondary text-navy">
                <s.icon className="h-6 w-6" />
              </div>
              <h3 className="text-lg font-semibold">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}